/* eslint-disable */

<template>
    <v-form
        v-model="valid"
        ref="locationFormEdit">
       <v-container>
            <v-row no-gutters>
                <v-col cols="8" md="8">
                    <v-text-field dense outlined
                        label="nome sede"
                        v-model="loc.name"
                    ></v-text-field>
                </v-col>
                <v-col cols="4" class="d-flex justify-end" v-if="enable_registered">
                    <v-checkbox
                        v-model="loc.is_registered"
                        dense outline hide-details
                        label="sede legale">
                </v-checkbox>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="10">
                <v-text-field dense outlined
                    label="indirizzo*"
                    v-model="loc.address"
                    :rules="[rules.mandatory, rules.nameRules]"
                    required
                ></v-text-field></v-col>
                <v-col cols="2" class="pl-2">   
                <v-text-field dense outlined
                    label="n° civico*"
                    v-model="loc.addrNum"
                    :rules="[rules.mandatory]"
                    required
                ></v-text-field>   
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="12" md="6">
                    <v-combobox dense outlined
                        :items="districts.cities"
                        item-value="id"
                        item-text="name"
                        label="città*"
                        v-model="city"
                        :rules="[rules.mandatory]"
                        required
                        return-object
                        @change="changeCity"
                    ></v-combobox>
                </v-col>
                <v-col cols="4" md="2" class="pl-md-2">
                    <v-combobox dense outlined
                        :items="zips"
                        label="CAP*"
                        v-model="loc.zip"
                        :rules="[rules.mandatory]"
                        required
                    ></v-combobox>
                </v-col>
                <v-col cols="8" md="4" class="pl-2">
                    <v-combobox dense outlined
                        label="provincia*"
                        :items="districts.districts"
                        v-model="district"
                        item-value="id"
                        item-text="name"
                        return-object
                        @change="changeDistrict"
                        :rules="[rules.mandatory]"
                        required
                    ></v-combobox>
                </v-col>
            <!--v-flex xs4 pr-2 pl-2>
                <v-text-field dense outlined
                    label="nazione"
                    v-model="loc.country"
                    :rules="[rules.mandatory, rules.nameRules]"
                    required
                ></v-text-field>
            </v-flex-->
                
            </v-row>
            <v-row>
                <v-col cols="8">   
                    <v-autocomplete dense outlined
                    label="seleziona contatti*"
                    :items="l_contacts"
                    multiple
                    small-chips
                    :rules="[rules.mandatory, rules.arrayRules]"
                    item-text="name"
                    item-value="id"
                    v-model="loc.contacts">
                    </v-autocomplete>
                </v-col>
                <v-col v-if="add_contact_enable" cols="4" class="d-flex justify-end align-content-center pl-md-2">
                    <v-btn color="action" class="text-center" @click.stop="$emit('add_contact')"><v-icon small class="pr-1">add_box</v-icon>contatto</v-btn>
                </v-col>        
            </v-row>
       </v-container>
    </v-form>
</template>

<script>

// import _ from 'lodash'
import {f_rules} from "../../utils/commonUtils"

export default {
    data(){
        return {
            loc: {},
            valid: true,
            rules: f_rules,
            dialog: false,
            allow_edit_name: true,
            l_contacts: [],
            countries: [],
            zips: [],
            district: null,
            city: null,
            districts: {}
        }
    },
    props: [
        "o_loc", "contacts", "add_contact_enable", 'enable_registered'
    ],
    async mounted() {
        //this.allow_edit_name = !this.enable_registered
        this.l_contacts = this.contacts
        this.districts = await this.$store.state.$pouch.get('system', "district:ITALIA")
    },
    beforeDestroy() {
        this.loc = null
        this.client= null
        this.l_contacts = null
        this.countries = null
        this.zips = null
        this.district = null
        this.city = null
        this.districts= null
    },
    methods: {
        resetValidation() {
            //this.$refs.locationFormEdit.resetValidation()
        },
        initData(o_loc, contacts, loc_name){
            // console.log("initData",o_loc, contacts, loc_name )
            this.loc = _.cloneDeep(o_loc)
            this.l_contacts = contacts
            if (loc_name) {
                this.loc.name = loc_name
            }
            this.zips = []
            this.district = null
            this.city = null
            if (this.loc.city) {
                let res = this.districts.cities.filter(d => {return this.loc.city == d.name})
                if (res && res.length>0) {
                    this.city = res[0]
                } else {
                    this.city = {'name': this.loc.city, zip:[], district:''}
                    this.districts.cities.push(this.city)
                }
            }
            if (this.loc.district) {
                let res = this.districts.districts.filter(d => {return this.loc.district== d.id})
                if (res && res.length>0) {
                    this.district = res[0]
                } else {
                    this.district = {'name': this.loc.district, id: this.loc.district}
                    this.districts.districts.push(this.district)
                }
            }
        },
        getLocationData(){
            if (!this.loc.name.trim()) {
                this.loc.name = this.loc.city + ' - ' + this.loc.address +''+ this.loc.addrNum
            }
            // console.log("GET LOCATION DATA", this.loc)
            return this.loc
        },
        getValid(){
            return this.valid
        },
        cancel() {
            this.$emit('cancel')
        },
        changeCity(item) {
            if ( typeof(item) === "string") {
                this.loc.city= item
            } else {
                this.loc.city = item.name
            }
            this.loc.zip = ""
            this.zips = []
            if (item.zip) {
                this.zips = item.zip
                this.loc.zip = this.zips[0]
            } else {
                this.zips = []
            }
            if (item.district) {
                let res = this.districts.districts.filter(d => {return item.district == d.id})
                if (res && res.length>0) {
                    this.district = res[0]
                    this.loc.district = res[0].id
                }
            } else {
                this.district = null
            }
        },
        changeDistrict(item) {
            if (typeof(item) === "string") {
                this.loc.district = item
            } else {
                this.loc.district = item.id
            }
        },
        updateContacts(contacts) {
            // console.log('UPDATE CONTACTS')
            this.l_contacts = contacts
        }
    },
    watch: {
        valid: function(val, oldValue) {
            if (val != oldValue){
                //console.log("valid changed", val, oldValue, this.valid)
                this.$emit('validationChanged', this.valid)
            }
        }
    }
}
</script>

<style>

</style>
